import type {DefinedAction, GoToAction, MappedAction} from 'shared/defined-actions';
import {exists} from 'shared/utils/custom-utils';

export function isGoToMenuItemAction(action: DefinedAction): action is GoToAction {
    return 'path' in action && exists(action.path);
}

export function isMappedMenuItemAction(action: DefinedAction): action is MappedAction {
    return 'actionType' in action && exists(action.actionType);
}